import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import DealerTable from './components/DealerTable';
import DealerMap from './components/DealerMap';

class HeadlessLocator extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      endPoint: `https://firstbasegroundscrews.com/wp-json/wp/v2/pages/266`,
      dealers: null,
      load: 1,
    };

    this.getDealers().then((data) => {
      this.setState({ dealers: data });
    });
  }

  async getDealers() {
    const response = await fetch(this.state.endPoint);
    const data = await response.json();

    let filterData = [];

    data.acf.locations.map((location) => {
      if (location.locale === '') filterData.push(location);
      else if (this.findOne(location.locale.split(','), [this.props.locale]))
        filterData.push(location);
    });

    const preferedDealer = this.getPreferedDealer();

    if (this.props.locale == 'en_US') {
      const dataStruct = this.filterPreferedDealer(data.acf.locations, preferedDealer);
      return dataStruct;
    } else {
      const dataStruct = this.filterPreferedDealer(filterData, preferedDealer);
      return dataStruct;
    }
  }

  getPreferedDealer() {
    const urlObject = new URL(window.location.href);
    const searchParams = urlObject.searchParams.get('f');

    return searchParams;
  }

  filterPreferedDealer(data, prefered) {
    if (prefered == null) {
      return data;
    }

    let preferedData = [];
    const pro = prefered == 'pro';

    data.forEach((location) => {
      if (location.pro_dealer == pro) {
        preferedData.push(location);
      }
    });

    return preferedData;
  }

  findOne(haystack, arr) {
    return arr.some(function (v) {
      return haystack.indexOf(v) >= 0;
    });
  }

  switchButtonContent() {
    switch (this.getPreferedDealer()) {
      case 'pro': {
        return 'DIY';
      }
      case 'diy': {
        return 'Pro';
      }
      default: {
        return false;
      }
    }
  }

  switchProDiy(pro) {
    let param;
    if (pro) {
      param = 'pro';
    } else {
      param = 'diy';
    }

    this.setState({ load: this.state.load++ });

    let queryParams = new URL(window.location.href);
    queryParams.searchParams.set('f', param);
    history.replaceState(null, null, queryParams.toString());
    this.getDealers().then((data) => {
      this.setState({ dealers: data });
    });
  }

  render() {
    const content = this.switchButtonContent();
    let button = (
      <div className='fbDealerSwitch' data-pro-diy={this.getPreferedDealer()}>
        <p className='fbDealerSwitch__text'>DIY</p>
        <div className='fbDealerSwitch__switchContainer'>
          <button
            style={{
              width: '100%',
            }}
            className='fbDealerSwitch__switch'
            onClick={() => {
              this.switchProDiy(content == 'Pro');
            }}
          ></button>
        </div>
        <p className='fbDealerSwitch__text'>PRO</p>
      </div>
    );

    if (!content) {
      button = '';
    }

    return (
      <div
        className='fb_dealer_locator'
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DealerMap dealers={this.state.dealers} mapData={this.props} />
        {button}
        <DealerTable dealers={this.state.dealers} />
      </div>
    );
  }
}

const mapContainer = document.getElementById('headlessLocator');

ReactDOM.render(
  <HeadlessLocator
    lat={mapContainer.dataset.lat}
    lon={mapContainer.dataset.lon}
    zoom={mapContainer.dataset.zoom}
    locale={mapContainer.dataset.locale}
  />,
  mapContainer,
);
